import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { DataAnalyticsComponent } from './data-analytics.component';

/* istanbul ignore  next*/
const routes: Routes = [
  {
    path: '',
    // canActivate: [PrivilegeCheckerService],
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'Waste Dashboard',
        redirectTo: '/no-privilage'
      }
    },
    component: DataAnalyticsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataAnalyticsRoutingModule { }
